import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import ApiService from '../services/apiService';
import SearchNavigation from '../components/SearchNavigation';

const LatestLawPoints = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [blogPosts, setBlogPosts] = useState([]);
    const [searchText, setSearchText] = useState('');

    useEffect(() => {
        document.body.style.paddingTop = '0';
        return () => {
            document.body.style.paddingTop = '';
        };
    }, []);

    useEffect(() => {
        async function fetchData() {
            const payload = {
                requests: [{
                    mainkeys: ['ALL'],
                }],
                sortBy: 'year',
                sortOrder: 'desc',
                page: 1,
                pageSize: 100,
                inst: '',
                prompt: "Advance",
            };
            const apiResponse = await ApiService.getLawPoints(payload);
            setBlogPosts(apiResponse.hits || []);
            const searchResults = apiResponse.hits || [];
            const totalCount = apiResponse.total || 0;
            const courtsList = apiResponse.courtsList || [];
            const yearList = apiResponse.yearList || [];
            const resultsData = {
                results: searchResults,
                totalCount: totalCount,
                query: ``.trim(),
                searchType: 'Law Point',
                timestamp: new Date().toISOString(),
                courtsList: courtsList,
                yearList: yearList,
                searchData: {
                    mainkeys: ['ALL'],
                }
            };

            console.log('💾 Storing citation results with API filter data:', resultsData);
            localStorage.setItem('searchResults', JSON.stringify(resultsData));
            setIsLoading(false);
        }
        fetchData();
    }, []);

    const formatDate = (dateStr) => {
        if (dateStr) {
            try {
                if (dateStr.length === 8) {
                    const year = dateStr.substring(0, 4);
                    const month = dateStr.substring(4, 6);
                    const day = dateStr.substring(6, 8);
                    return `${day}/${month}/${year}`;
                }
                return dateStr;
            } catch {
                return dateStr;
            }
        }
        return 'Date not available';
    };

    const handleJudgementClick = (judgement) => {
        const currentIndex = blogPosts.findIndex(result => result.id === judgement.id);
        const navigationData = {
            currentIndex: currentIndex,
            results: blogPosts.map(result => ({
                keycode: result.id,
                title: '',
                court: '',
                date: ''
            })),
            searchQuery: '',
            totalResults: 100,
            currentPage: 1
        };

        sessionStorage.setItem('judgementNavigation', JSON.stringify(navigationData));
        navigate(`/judgement/${judgement.id}`);
    };

    const filteredPosts = blogPosts.filter(post =>
        post.lawPoint?.toLowerCase().includes(searchText.toLowerCase()) ||
        post.appellant?.toLowerCase().includes(searchText.toLowerCase()) ||
        post.respondent?.toLowerCase().includes(searchText.toLowerCase()) ||
        post.court?.toLowerCase().includes(searchText.toLowerCase())
    );

    if (isLoading) {
        return (
            <div className="lawpoints-layout">
                <Navbar />
                <SearchNavigation />
                <div className="lawpoints-main-content">
                    <div className="loading-state">
                        <i className="bx bx-loader-alt bx-spin"></i>
                        <p>Loading law points...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="lawpoints-layout">
            <Navbar />
            <SearchNavigation />

            <div className="lawpoints-main-content">
                {/* Hero Section */}
                <div className="lawpoints-hero">
                    <div className="hero-badge">
                        <i className="bx bx-file-find"></i>
                        <span>Law Points</span>
                    </div>
                    <h1 className="hero-title">Latest Law Points</h1>
                    <p className="hero-subtitle">
                        Fresh, concise legal principles extracted from recent judgments
                    </p>
                </div>

                {/* Container */}
                <div className="lawpoints-container">
                    {/* Search Box */}
                    <div className="search-header">
                        <div className="search-box">
                            <i className="bx bx-search search-icon"></i>
                            <input
                                type="text"
                                className="search-input"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                placeholder="Search law points, parties, courts..."
                            />
                            {searchText && (
                                <button
                                    className="clear-search"
                                    onClick={() => setSearchText('')}
                                >
                                    <i className="bx bx-x"></i>
                                </button>
                            )}
                        </div>
                        <div className="results-count">
                            Showing <strong>{filteredPosts.length}</strong> of <strong>{blogPosts.length}</strong> law points
                        </div>
                    </div>

                    {/* Law Points List */}
                    <div className="lawpoints-list">
                        {filteredPosts.length === 0 ? (
                            <div className="empty-state">
                                <i className="bx bx-search-alt"></i>
                                <p>No law points found matching "{searchText}"</p>
                            </div>
                        ) : (
                            filteredPosts.map((post, index) => (
                                <article
                                    key={index}
                                    className="lawpoint-card"
                                    onClick={() => handleJudgementClick(post)}
                                >
                                    <div className="lawpoint-number">
                                        <span>{index + 1}</span>
                                    </div>

                                    <div className="lawpoint-content">
                                        <div
                                            className="lawpoint-text"
                                            dangerouslySetInnerHTML={{
                                                __html: post.lawPoint
                                                    ?.toString()
                                                    .replace('\n<br>', '\n<br><br>') || ''
                                            }}
                                        />

                                        <div className="lawpoint-meta">
                                            <div className="case-info">
                                                <i className="bx bx-building"></i>
                                                <span className="parties">
                                                    {post.appellant} <strong>vs.</strong> {post.respondent}
                                                </span>
                                            </div>

                                            <div className="meta-divider"></div>

                                            <div className="meta-details">
                                                <div className="meta-item date">
                                                    <i className="bx bx-calendar"></i>
                                                    <span>{formatDate(post.date)}</span>
                                                </div>
                                                <div className="meta-item court">
                                                    <i className="bx bx-landmark"></i>
                                                    <span>{post.court}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="lawpoint-arrow">
                                        <i className="bx bx-right-arrow-alt"></i>
                                    </div>
                                </article>
                            ))
                        )}
                    </div>
                </div>
            </div>

            <style>{`
                /* ============================================
                   BASE LAYOUT
                ============================================ */
                .lawpoints-layout {
                    min-height: 100vh;
                    background: #fafafa;
                }

                .lawpoints-main-content {
                    padding-top: 140px;
                    width: 100%;
                }

                /* ============================================
                   HERO SECTION
                ============================================ */
                .lawpoints-hero {
                    background: linear-gradient(135deg, #E91E63 0%, #E91E64 25%, #c41849 75%, #D81B60 100%);
                    padding: 50px 20px 40px;
                    text-align: center;
                    color: white;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
                }

                .hero-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    padding: 8px 20px;
                    background: rgba(255, 255, 255, 0.2);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255, 255, 255, 0.3);
                    border-radius: 50px;
                    font-size: 13px;
                    font-weight: 600;
                    margin-bottom: 16px;
                }

                .hero-badge i {
                    font-size: 16px;
                }

                .hero-title {
                    font-size: 2rem;
                    font-weight: 800;
                    margin: 0 0 10px 0;
                    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
                    letter-spacing: -0.5px;
                    line-height: 1.2;
                }

                .hero-subtitle {
                    font-size: 1rem;
                    opacity: 0.95;
                    margin: 0;
                    font-weight: 400;
                }

                /* ============================================
                   CONTAINER
                ============================================ */
                .lawpoints-container {
                    max-width: 1200px;
                    margin: -30px auto 0;
                    padding: 0 20px 40px;
                    position: relative;
                    z-index: 10;
                }

                /* ============================================
                   SEARCH HEADER
                ============================================ */
                .search-header {
                    background: white;
                    border-radius: 16px;
                    padding: 20px 24px;
                    margin-bottom: 24px;
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    flex-wrap: wrap;
                }

                .search-box {
                    position: relative;
                    flex: 1;
                    min-width: 280px;
                }

                .search-icon {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.25rem;
                    color: #9ca3af;
                    pointer-events: none;
                }

                .search-input {
                    width: 100%;
                    padding: 12px 45px 12px 48px;
                    border: 2px solid #e5e7eb;
                    border-radius: 12px;
                    font-size: 0.95rem;
                    transition: all 0.3s ease;
                    background: #fafafa;
                }

                .search-input:focus {
                    outline: none;
                    border-color: #E91E63;
                    background: white;
                    box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.1);
                }

                .clear-search {
                    position: absolute;
                    right: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 24px;
                    height: 24px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #e5e7eb;
                    border: none;
                    border-radius: 50%;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }

                .clear-search:hover {
                    background: #d1d5db;
                }

                .clear-search i {
                    font-size: 1rem;
                    color: #6b7280;
                }

                .results-count {
                    font-size: 0.95rem;
                    color: #6b7280;
                    white-space: nowrap;
                }

                .results-count strong {
                    color: #E91E63;
                    font-weight: 700;
                }

                /* ============================================
                   LAW POINTS LIST
                ============================================ */
                .lawpoints-list {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .lawpoint-card {
                    background: white;
                    border-radius: 16px;
                    padding: 24px;
                    display: flex;
                    gap: 20px;
                    align-items: flex-start;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border: 2px solid #f0f0f0;
                    position: relative;
                    overflow: hidden;
                }

                .lawpoint-card::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 4px;
                    height: 100%;
                    background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
                    transform: scaleY(0);
                    transition: transform 0.3s ease;
                }

                .lawpoint-card:hover::before {
                    transform: scaleY(1);
                }

                .lawpoint-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 30px rgba(245, 166, 35, 0.15);
                    border-color: #E91E63;
                }

                .lawpoint-number {
                    flex-shrink: 0;
                    width: 48px;
                    height: 48px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
                    border-radius: 12px;
                    color: white;
                    font-size: 1.1rem;
                    font-weight: 700;
                }

                .lawpoint-content {
                    flex: 1;
                    min-width: 0;
                }

                .lawpoint-text {
                    font-size: 1rem;
                    line-height: 1.7;
                    color: #1a1a1a;
                    margin-bottom: 16px;
                    font-weight: 500;
                }

                .lawpoint-text br {
                    display: block;
                    margin: 8px 0;
                    content: '';
                }

                .lawpoint-meta {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    padding-top: 12px;
                    border-top: 1px solid #f0f0f0;
                }

                .case-info {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 0.95rem;
                }

                .case-info i {
                    font-size: 1.1rem;
                    color: #E91E63;
                }

                .parties {
                    color: #374151;
                }

                .parties strong {
                    color: #1a1a1a;
                    margin: 0 6px;
                }

                .meta-divider {
                    height: 1px;
                    background: #f0f0f0;
                }

                .meta-details {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 20px;
                }

                .meta-item {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 0.9rem;
                }

                .meta-item i {
                    font-size: 1rem;
                }

                .meta-item.date {
                    color: #059669;
                }

                .meta-item.date i {
                    color: #059669;
                }

                .meta-item.court {
                    color: #dc2626;
                }

                .meta-item.court i {
                    color: #dc2626;
                }

                .lawpoint-arrow {
                    flex-shrink: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    background: #f3f4f6;
                    transition: all 0.3s ease;
                }

                .lawpoint-arrow i {
                    font-size: 1.25rem;
                    color: #9ca3af;
                    transition: all 0.3s ease;
                }

                .lawpoint-card:hover .lawpoint-arrow {
                    background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
                    transform: scale(1.1);
                }

                .lawpoint-card:hover .lawpoint-arrow i {
                    color: white;
                    transform: translateX(3px);
                }

                /* ============================================
                   LOADING STATE
                ============================================ */
                .loading-state {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 60vh;
                    gap: 16px;
                }

                .loading-state i {
                    font-size: 3rem;
                    color: #E91E63;
                }

                .loading-state p {
                    font-size: 1.1rem;
                    color: #6b7280;
                    margin: 0;
                }

                /* ============================================
                   EMPTY STATE
                ============================================ */
                .empty-state {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 80px 20px;
                    text-align: center;
                }

                .empty-state i {
                    font-size: 4rem;
                    color: #d1d5db;
                    margin-bottom: 16px;
                }

                .empty-state p {
                    font-size: 1.1rem;
                    color: #6b7280;
                    margin: 0;
                }

                /* ============================================
                   RESPONSIVE DESIGN
                ============================================ */
                @media (max-width: 768px) {
                    .lawpoints-main-content {
                        padding-top: 130px;
                    }

                    .lawpoints-hero {
                        padding: 35px 15px 30px;
                    }

                    .hero-title {
                        font-size: 1.6rem;
                    }

                    .hero-subtitle {
                        font-size: 0.95rem;
                    }

                    .lawpoints-container {
                        margin-top: -20px;
                        padding: 0 15px 30px;
                    }

                    .search-header {
                        flex-direction: column;
                        align-items: stretch;
                        padding: 16px;
                    }

                    .search-box {
                        min-width: 100%;
                    }

                    .results-count {
                        text-align: center;
                    }

                    .lawpoint-card {
                        flex-direction: column;
                        gap: 16px;
                        padding: 20px;
                    }

                    .lawpoint-number {
                        align-self: flex-start;
                    }

                    .lawpoint-arrow {
                        align-self: flex-end;
                    }

                    .meta-details {
                        flex-direction: column;
                        gap: 12px;
                    }
                }

                @media (max-width: 480px) {
                    .hero-title {
                        font-size: 1.4rem;
                    }

                    .hero-badge {
                        padding: 6px 14px;
                        font-size: 12px;
                    }

                    .lawpoint-text {
                        font-size: 0.95rem;
                    }
                }

                /* ============================================
                   REMOVE TOP WHITE SPACE
                ============================================ */
                body {
                    margin: 0 !important;
                    padding: 0 !important;
                }
            `}</style>
        </div>
    );
};

export default LatestLawPoints;